import styled from "@emotion/styled";

import { EmphasizedMessage } from "../composable";

const Container = styled.div`
  display: flex;
  width: 100%;

  gap: 4px;
  align-items: center;
`;

const NotConfiguredText = styled.span`
  font-style: italic;
  opacity: 0.5;
`;

const EmphasizedText = styled.span`
  color: ${({ theme }) => theme.secondary};
  font-weight: bold;
`;

type Props = {
  configured: boolean;
  title: string;
  configuredMessage: string;
  notConfiguredMessage: string;
  values?: Record<string, unknown>;
};

export const PredicateSummary = ({
  configured,
  title,
  configuredMessage,
  notConfiguredMessage,
  values = {},
}: Props) => {
  return (
    <Container>
      {configured && (
        <EmphasizedMessage content={configuredMessage} values={values} components={{ emphasized: EmphasizedText }} />
      )}

      {!configured && (
        <>
          <EmphasizedMessage content={title} components={{ emphasized: EmphasizedText }} />
          <NotConfiguredText>{notConfiguredMessage}</NotConfiguredText>
        </>
      )}
    </Container>
  );
};
